import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'

const RenameDeletePopup: React.FC<{
  onClose: () => void
  onRename: () => void
  onDelete: () => void
  deleteText?: string
  title: string
}> = ({
  onClose,
  onRename,
  onDelete,
  title,
  deleteText,
}) => {
  return (
    <Popup onClose={onClose}>
      <div className="title">
        {title}
      </div>
      <div className="buttonStack">
        <div className="buttonRow">
          <Button buttonStyle="green" onClick={onRename}>
            Rename
          </Button>
          <Button
            buttonStyle="redStroke"
            onClick={onDelete}
          >
            {deleteText ?? 'Delete'}
          </Button>
        </div>
        <Button onClick={onClose}>
          Close
        </Button>
      </div>
    </Popup>
  )
}

export default RenameDeletePopup